// extracted by mini-css-extract-plugin
module.exports = {"layout":"_ae82995","gridLayout":"_b38e60b","rightSection":"_e1dfa04","leftSection":"_30fa68c"};